// extracted by mini-css-extract-plugin
export default {"comment_box":"index_comment_box_RC71b"};